module.exports = __webpack_public_path__ + "img/beard-1.c260c73a.svg";